/* Maison Panorama — scripts du thème (v2 : mobile, panier latéral, animations) */
(function () {
  var cfg = window.mpTheme || {};
  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = function () { return window.innerWidth < 980; };

  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: cents % 100 ? 2 : 0 });
  }
  function lock(on) { root.classList.toggle('is-locked', on); }

  /* ---------- Toasts ---------- */
  var toasts = document.querySelector('[data-toasts]');
  function toast(msg, type) {
    if (!toasts) return;
    var t = document.createElement('div');
    t.className = 'toast' + (type ? ' toast--' + type : '');
    t.textContent = msg;
    toasts.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('in'); });
    setTimeout(function () { t.classList.remove('in'); setTimeout(function () { t.remove(); }, 400); }, 3200);
  }

  /* ---------- Barre d'annonce : rotation des messages sur mobile ---------- */
  var announce = document.querySelector('[data-announce]');
  if (announce) {
    var msgs = announce.querySelectorAll('.announce__msg'), ai = 0;
    if (msgs.length > 1) setInterval(function () {
      if (!isMobile()) return;
      msgs[ai].classList.remove('is-on'); msgs[ai].classList.add('is-out');
      var prev = msgs[ai];
      setTimeout(function () { prev.classList.remove('is-out'); }, 500);
      ai = (ai + 1) % msgs.length;
      msgs[ai].classList.add('is-on');
    }, 3500);
  }

  /* ---------- En-tête : ombre au défilement, se cache en descendant (mobile) ---------- */
  var header = document.querySelector('[data-header]');
  var lastY = window.scrollY;
  function showHeader() { if (header) header.classList.remove('is-hidden'); }
  window.addEventListener('scroll', function () {
    if (!header) return;
    var y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 8);
    if (isMobile() && !root.classList.contains('is-locked')) {
      if (y > lastY + 4 && y > 160) header.classList.add('is-hidden');
      else if (y < lastY - 4) header.classList.remove('is-hidden');
    } else header.classList.remove('is-hidden');
    lastY = y;
  }, { passive: true });

  /* ---------- Tiroirs (menu mobile + panier) ---------- */
  function openDrawer(el, focusSel) {
    if (!el) return;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lock(true);
    var f = el.querySelector(focusSel || '[tabindex="-1"]');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 50);
  }
  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open, .mnav.is-open')) lock(false);
  }

  var mnav = document.querySelector('[data-mobile-nav]');
  var menuBtn = document.querySelector('[data-menu-open]');
  if (mnav && menuBtn) {
    menuBtn.addEventListener('click', function () { openDrawer(mnav, '.mnav__panel'); menuBtn.setAttribute('aria-expanded', 'true'); });
    mnav.querySelectorAll('[data-menu-close]').forEach(function (b) {
      b.addEventListener('click', function () { closeDrawer(mnav); menuBtn.setAttribute('aria-expanded', 'false'); });
    });
  }

  var drawer = document.querySelector('[data-cart-drawer]');
  function bindDrawer() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-cart-close]').forEach(function (b) {
      b.onclick = function () { closeDrawer(drawer); };
    });
    drawer.querySelectorAll('[data-qty-change]').forEach(function (b) {
      b.onclick = function () {
        var item = b.closest('[data-key]');
        changeLine(item.getAttribute('data-key'), Number(b.getAttribute('data-qty-change')), item);
      };
    });
  }
  bindDrawer();
  document.querySelectorAll('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!drawer || cfg.template === 'cart') return;
      e.preventDefault(); openDrawer(drawer, '.drawer__panel');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(drawer); closeDrawer(mnav); }
  });

  function updateBadge(count) {
    document.querySelectorAll('[data-cart-badge]').forEach(function (b) {
      b.textContent = count; b.hidden = !count;
      b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
    });
  }
  /* Date de livraison estimée : +3 à +5 jours ouvrés */
  function eta() {
    var add = function (n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
    var f = function (d) { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); };
    var txt = 'entre le ' + f(add(3)) + ' et le ' + f(add(5));
    document.querySelectorAll('[data-eta]').forEach(function (el) { el.textContent = txt; });
  }
  eta();
  function renderDrawer(html) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]');
    var old = drawer.querySelector('[data-cart-inner]');
    if (fresh && old) { old.replaceWith(fresh); bindDrawer(); eta(); updateBadge(Number(fresh.getAttribute('data-count')) || 0); }
  }
  function changeLine(key, quantity, itemEl) {
    if (itemEl) itemEl.classList.add('is-busy');
    fetch(cfg.cartChange || '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (data) {
      var go = function () { renderDrawer(data.sections && data.sections['cart-drawer']); };
      if (quantity === 0 && itemEl && !reduceMotion) { itemEl.classList.add('is-leaving'); setTimeout(go, 280); } else go();
    }).catch(function () { if (itemEl) itemEl.classList.remove('is-busy'); toast('Oups, réessayez dans un instant.', 'error'); });
  }

  /* ---------- Image qui « vole » vers le panier ---------- */
  function flyToCart(img) {
    var target = document.querySelector('[data-cart-icon]');
    if (!img || !target || reduceMotion || !img.getBoundingClientRect) return Promise.resolve();
    showHeader();
    var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width) return Promise.resolve();
    var size = Math.min(a.width, a.height, 260);
    var c = document.createElement('img');
    c.src = img.currentSrc || img.src; c.alt = ''; c.className = 'fly';
    c.style.cssText = 'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;filter:' + (img.style.filter || 'none');
    document.body.appendChild(c);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var anim = c.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '16px' },
      { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 90) + 'px) scale(.55)', opacity: 1, borderRadius: '30%', offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08)', opacity: 0.6, borderRadius: '50%' }
    ], { duration: 800, easing: 'cubic-bezier(.55,0,.35,1)' });
    var done = new Promise(function (r) { anim.onfinish = r; setTimeout(r, 950); });
    return done.then(function () {
      if (!c.parentNode) return;
      c.remove();
      target.classList.remove('bump'); void target.offsetWidth; target.classList.add('bump');
    });
  }

  /* ---------- Révélation au défilement ---------- */
  if ('IntersectionObserver' in window && !reduceMotion && !cfg.designMode) {
    var sel = '.tiles > *, .split, .usp-band .usp > div, .intro h1, .styles > *, .hero, .row-head, .cards > *, .grid-products > *, .usp > div, .step, .rooms > *, .sample, .faq details, .info > div, .mats > div, .always > div, .collection-head, .page h1, .cart-item';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll(sel).forEach(function (el) {
      var i = Array.prototype.indexOf.call(el.parentNode.children, el) % 6;
      el.style.setProperty('--d', (i * 70) + 'ms');
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  /* Sécurité : tout bloc déjà à l'écran s'affiche, même si l'observateur tarde */
  setTimeout(function () {
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('in');
    });
  }, 1200);

  /* ---------- Images : fondu à l'apparition ---------- */
  document.querySelectorAll('.card .ph img, .room img, .style img, .slide img, .sample .swatches img').forEach(function (img) {
    if (img.complete && img.naturalWidth) return;
    img.classList.add('fade');
    img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
  });

  /* ---------- Carrousels (flèches sur ordinateur) ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-track]'); if (!track) return;
    var step = function (dir) { track.scrollBy({ left: dir * track.clientWidth * 0.75, behavior: reduceMotion ? 'auto' : 'smooth' }); };
    var p = c.querySelector('[data-prev]'), n = c.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
    var sync = function () {
      if (p) p.disabled = track.scrollLeft < 8;
      if (n) n.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
    };
    track.addEventListener('scroll', sync, { passive: true }); sync();
  });

  /* ---------- FAQ et accordéons : ouverture fluide ---------- */
  document.querySelectorAll('.faq details, footer details.fcol').forEach(function (d) {
    var summary = d.querySelector('summary'); if (!summary) return;
    var anim = null;
    summary.addEventListener('click', function (e) {
      if (reduceMotion || !d.animate) return;
      if (d.classList.contains('fcol') && !isMobile()) return;
      e.preventDefault();
      if (anim) { anim.cancel(); anim = null; }
      var cs = getComputedStyle(d), pad = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
      var start = d.offsetHeight, closed = summary.offsetHeight + pad;
      d.style.overflow = 'hidden';
      if (!d.open) {
        d.open = true; d.classList.add('is-opening');
        anim = d.animate({ height: [start + 'px', d.offsetHeight + 'px'] }, { duration: 340, easing: 'cubic-bezier(.2,.7,.2,1)' });
        anim.onfinish = function () { anim = null; d.style.overflow = ''; d.classList.remove('is-opening'); };
      } else {
        anim = d.animate({ height: [start + 'px', closed + 'px'] }, { duration: 280, easing: 'cubic-bezier(.4,0,.2,1)' });
        anim.onfinish = function () { anim = null; d.open = false; d.style.overflow = ''; };
      }
    });
  });

  /* ---------- Pied de page : accordéons fermés sur mobile ---------- */
  if (isMobile()) document.querySelectorAll('footer details.fcol').forEach(function (d) { d.removeAttribute('open'); });

  /* ---------- Fiche produit ---------- */
  document.querySelectorAll('[data-product]').forEach(function (pRoot) {
    var form = document.getElementById(pRoot.getAttribute('data-form-id'));
    var variants = [];
    try { variants = JSON.parse(pRoot.querySelector('[data-product-json]').textContent); } catch (e) {}
    var variantInput = form && form.querySelector('[data-variant-input]');
    var qty = form && form.querySelector('[data-qty]');
    var unitEl = pRoot.querySelector('[data-unit-price]');
    var surMesure = pRoot.getAttribute('data-sur-mesure') === 'true';
    var atc = form && form.querySelector('[data-atc]');
    var msg = form && form.querySelector('[data-form-msg]');
    var filter = 'none';
    var lastTotal = 0, totalCents = 0;

    function currentVariant() {
      var id = variantInput ? Number(variantInput.value) : null;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }

    /* Galerie glissable */
    var track = pRoot.querySelector('[data-gallery-track]');
    var slides = track ? track.querySelectorAll('.slide') : [];
    var dots = pRoot.querySelectorAll('[data-gallery-dots] button');
    var thumbs = pRoot.querySelectorAll('[data-thumb]');
    function currentImg() {
      if (!track) return null;
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      var s = slides[i] || slides[0];
      return s && s.querySelector('img');
    }
    function goTo(i) { if (track) track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); }
    function markActive() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
    }
    if (track && slides.length > 1) {
      track.addEventListener('scroll', function () { window.requestAnimationFrame(markActive); }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-thumb'))); }); });
    }
    /* Zoom au survol (ordinateur) */
    pRoot.querySelectorAll('[data-zoom]').forEach(function (s) {
      var img = s.querySelector('img'); if (!img) return;
      s.addEventListener('mousemove', function (e) {
        if (isMobile()) return;
        var r = s.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        s.classList.add('is-zoom');
      });
      s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
    });

    /* Variantes (matière) */
    pRoot.querySelectorAll('[data-variants] input').forEach(function (r) {
      r.addEventListener('change', function () {
        if (variantInput) variantInput.value = r.value;
        if (unitEl) { unitEl.textContent = money(Number(r.getAttribute('data-price'))); unitEl.classList.remove('flash'); void unitEl.offsetWidth; unitEl.classList.add('flash'); }
        update();
      });
    });

    /* Barre d'achat collante (mobile) */
    var sticky = pRoot.querySelector('[data-sticky-atc]');
    var stickyPrice = pRoot.querySelector('[data-sticky-price]');
    var stickySub = pRoot.querySelector('[data-sticky-sub]');
    var stickyBtn = pRoot.querySelector('[data-sticky-btn]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var atcInView = false;
      var refreshSticky = function () {
        var show = isMobile() && !atcInView && window.scrollY > 120;
        if (sticky.classList.contains('is-on') === show) return;
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-sticky', show);
      };
      new IntersectionObserver(function (en) { atcInView = en[0].isIntersecting; refreshSticky(); }, { threshold: 0 }).observe(atc);
      window.addEventListener('scroll', refreshSticky, { passive: true });
      stickyBtn.addEventListener('click', function () {
        if (surMesure && !(totalCents > 0)) {
          var dims = pRoot.querySelector('[data-dims]');
          dims.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          setTimeout(function () { var w0 = pRoot.querySelector('[data-w]'); if (w0) w0.focus({ preventScroll: true }); }, 450);
          return;
        }
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }

    /* Ajout au panier en AJAX */
    function setMsg(t) { if (!msg) return; msg.textContent = t || ''; msg.hidden = !t; }
    function shake(el) { if (!el) return; el.classList.remove('shake'); void el.offsetWidth; el.classList.add('shake'); }
    if (form && atc) form.addEventListener('submit', function (e) {
      e.preventDefault();
      setMsg('');
      if (surMesure) {
        var W = parseFloat(pRoot.querySelector('[data-w]').value), H = parseFloat(pRoot.querySelector('[data-h]').value);
        if (!(W >= 50 && H >= 50)) {
          setMsg('Indiquez la largeur et la hauteur de votre mur (en cm).');
          shake(pRoot.querySelector('[data-dims]'));
          var first = pRoot.querySelector(W >= 50 ? '[data-h]' : '[data-w]');
          first.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
          return;
        }
        if (H > 360 || W > 1200) { setMsg('Dimensions hors limites (max. 1200 × 360 cm). Écrivez-nous pour un mur plus grand.'); shake(pRoot.querySelector('[data-dims]')); return; }
      }
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var label = atc.querySelector('span');
      atc.classList.add('is-loading'); atc.disabled = true;
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      var img = currentImg();
      fetch(cfg.cartAdd || '/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          atc.classList.remove('is-loading');
          if (!res.ok) { atc.disabled = false; setMsg(res.d.description || res.d.message || 'Impossible d’ajouter ce produit.'); return; }
          atc.classList.add('is-done'); if (label) label.textContent = 'Ajouté au panier ✓';
          flyToCart(img).then(function () {
            if (res.d.sections) renderDrawer(res.d.sections['cart-drawer']);
            else fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (s) { renderDrawer(s['cart-drawer']); });
            setTimeout(function () { openDrawer(drawer, '.drawer__panel'); }, 120);
          });
          setTimeout(function () { atc.classList.remove('is-done'); atc.disabled = false; if (label) label.textContent = 'Ajouter au panier'; }, 2400);
        })
        .catch(function () { atc.classList.remove('is-loading'); atc.disabled = false; form.submit(); });
    });

    if (!surMesure) return;

    /* ---------- Configurateur sur mesure ---------- */
    var w = pRoot.querySelector('[data-w]'), h = pRoot.querySelector('[data-h]');
    var total = pRoot.querySelector('[data-total]'), frame = pRoot.querySelector('[data-frame]');
    var preview = pRoot.querySelector('[data-preview]'), fmt = pRoot.querySelector('[data-fmt]');
    var areaInput = pRoot.querySelector('[data-area-input]'), colorInput = pRoot.querySelector('[data-colorway-input]');
    var previewImg = pRoot.querySelector('[data-preview-img]'), mirror = pRoot.querySelector('[data-mirror]');

    pRoot.querySelectorAll('[data-colorways] button').forEach(function (b) {
      b.addEventListener('click', function () {
        pRoot.querySelectorAll('[data-colorways] button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        filter = b.getAttribute('data-filter');
        if (colorInput) colorInput.value = b.getAttribute('data-name');
        pRoot.querySelectorAll('.slide img').forEach(function (im) { im.style.filter = filter; });
        update();
      });
    });
    if (mirror) mirror.addEventListener('change', update);

    var raf = null, rafEnd = null;
    function countTo(el, from, to) {
      if (raf) cancelAnimationFrame(raf);
      if (rafEnd) clearTimeout(rafEnd);
      rafEnd = setTimeout(function () { if (raf) cancelAnimationFrame(raf); el.textContent = money(to); }, 520);
      if (reduceMotion || !from || document.hidden) { el.textContent = money(to); return; }
      var t0 = null, dur = 450;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = money(Math.round((from + (to - from) * e) / 100) * 100);
        if (p < 1) raf = requestAnimationFrame(step); else el.textContent = money(to);
      }
      raf = requestAnimationFrame(step);
    }

    function update() {
      var v = currentVariant(); if (!v || !w || !h) return;
      var W = parseFloat(w.value), H = parseFloat(h.value);
      var flip = mirror && mirror.checked;
      if (previewImg) { previewImg.style.filter = filter; previewImg.style.transform = flip ? 'scaleX(-1)' : ''; }
      if (frame) frame.style.filter = filter;
      pRoot.querySelectorAll('.slide img').forEach(function (im) { im.style.transform = flip ? 'scaleX(-1)' : ''; });
      if (!(W >= 50 && H >= 50)) {
        totalCents = 0; lastTotal = 0;
        if (frame) frame.style.display = 'none';
        if (fmt) fmt.textContent = 'Vos dimensions';
        total.classList.remove('is-ready');
        total.innerHTML = 'Entrez vos dimensions pour voir le prix exact.';
        if (qty) qty.value = 1;
        if (stickyPrice) stickyPrice.innerHTML = money(v.price) + '<small>/m²</small>';
        if (stickySub) stickySub.textContent = 'Prix exact selon vos dimensions';
        if (stickyBtn) stickyBtn.textContent = 'Mes dimensions';
        return;
      }
      if (H > 360) { totalCents = 0; total.classList.remove('is-ready'); total.innerHTML = 'Hauteur maximale : 360 cm. Pour un mur plus haut, écrivez-nous.'; return; }
      var area = W * H / 10000, billed = Math.max(1, Math.ceil(area)), les = Math.ceil(W / 76);
      if (qty) qty.value = billed;
      if (areaInput) areaInput.value = area.toFixed(2).replace('.', ',');
      totalCents = v.price * billed;
      if (!total.classList.contains('is-ready')) {
        total.innerHTML = '<span class="total__sub" data-total-sub></span><strong data-total-num></strong><span class="total__ship">Livraison offerte · fabriqué en Europe</span>';
        total.classList.add('is-ready');
      }
      total.querySelector('[data-total-sub]').textContent = 'Surface ' + area.toFixed(2).replace('.', ',') + ' m² → facturée ' + billed + ' m² · ' + les + ' lés de 76 cm';
      if (totalCents !== lastTotal) {
        countTo(total.querySelector('[data-total-num]'), lastTotal, totalCents);
        total.classList.remove('pulse'); void total.offsetWidth; total.classList.add('pulse');
      }
      lastTotal = totalCents;
      if (stickyPrice) stickyPrice.textContent = money(totalCents);
      if (stickySub) stickySub.textContent = W + ' × ' + H + ' cm · ' + billed + ' m²';
      if (stickyBtn) stickyBtn.textContent = 'Ajouter au panier';
      if (fmt) fmt.textContent = W + ' × ' + H + ' cm';
      if (frame && preview) {
        frame.style.display = '';
        var pw = preview.clientWidth, ph = preview.clientHeight, r = W / H, fw = pw * 0.82, fh = fw / r;
        if (fh > ph * 0.82) { fh = ph * 0.82; fw = fh * r; }
        frame.style.width = fw + 'px'; frame.style.height = fh + 'px';
        frame.style.backgroundSize = pw + 'px ' + ph + 'px';
        frame.style.backgroundPosition = (-(pw - fw) / 2) + 'px ' + (-(ph - fh) / 2) + 'px';
        frame.style.transform = 'translate(-50%,-50%)' + (flip ? ' scaleX(-1)' : '');
      }
    }
    [w, h].forEach(function (el) { if (el) el.addEventListener('input', update); });
    window.addEventListener('resize', update);
    update();
  });
})();
